<template lang="pug">
y-dialog(v-model="showDialog" :max-width="450" persistent content-class="round-lg add-log-note-dialog")
  v-card.round-lg
    //- Header
    v-card-title.pa-0
      .d-flex.align-center.justify-space-between.px-6.py-3.w-full
        .invisible
          v-icon(size="20") mdi-close
        .text-lg.font-semibold.neutral700--text {{ isEdit ? 'Edit note' : 'Add logs note' }}
        v-btn(icon small @click="closeDialog")
          v-icon(size="20" color="neutral700") mdi-close
    v-divider

    //- Body
    v-card-text.pa-6
      //- Log entry preview
      v-card.round-lg.mb-6(outlined)
        .d-flex.align-start.pa-3.gap-3
          //- Icon
          .log-icon.d-flex.align-center.justify-center.rounded-circle.neutral300
            v-icon(size="16" color="neutral500") {{ getIcon(logTag) }}

          //- Content
          .flex-grow-1.min-width-0
            .text-sm.neutral700--text {{ logActivity }}
            .d-flex.align-center.mt-1
              v-icon(size="12" color="neutral500") $yzi-user-edit
              .text-xs.neutral500--text.ml-1 {{ logUserName }},
              .text-xs.neutral500--text.ml-1 {{ logCreated | humanizeDate }}, {{ logCreated | displayTime2 }}

      //- Note input
      .text-sm.font-medium.neutral700--text.mb-1 Note
      v-textarea.round-lg(v-model="noteText" placeholder="Enter note" outlined dense hide-details rows="3" background-color="white")

    v-divider

    //- Footer
    v-card-actions.px-4.py-3
      v-spacer
      y-button.mr-2(:label="$t('cancel')" text color="neutral700" size="sm" button-class="px-3" @click="closeDialog")
      y-button(label="Save" size="sm" dark :loading="isLoading" @click="saveNote")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: { type: Boolean, default: false },
    log: { type: Object, default: null }
  },
  data: () => ({
    isLoading: false,
    noteText: ''
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isEdit () {
      return this.log?.isEdit
    },
    logActivity () {
      return this.log?.activity || ''
    },
    logTag () {
      return this.log?.tag || ''
    },
    logUserName () {
      const user = this.log?.user
      if (user) {
        if (user.first_name || user.last_name) {
          return `${user.first_name || ''} ${user.last_name || ''}`.trim()
        }
        if (user.name) return user.name
      }
      return 'System'
    },
    logCreated () {
      return this.log?.created || ''
    }
  },
  watch: {
    open: {
      immediate: true,
      handler (val) {
        if (val && this.log?.note) {
          this.noteText = this.log.note
        } else if (!val) {
          this.noteText = ''
        }
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    getIcon (tag) {
      switch (tag) {
        case 'add_transaction':
          return '$yzi-credit-card-01'
        case 'edit_transaction':
        case 'edit_tax':
          return '$yzi-edit-01'
        case 'delete_transaction':
        case 'delete_tax':
        case 'delete_adjustment':
          return 'mdi-close'
        case 'add_tax':
        case 'add_adjustment':
          return 'mdi-percent'
        case 'complete_consultation':
          return '$yzi-user-check-01'
        case 'complete_visit':
          return '$yzi-receipt-check'
        default:
          return 'mdi-receipt'
      }
    },
    async saveNote () {
      if (!this.noteText.trim()) {
        this.showMessage(['error', 'Please enter a note'])
        return
      }
      this.isLoading = true
      try {
        await this.$axios.patch(`/actions/${this.log.id}`, { note: this.noteText.trim() })
        this.showMessage(['success', this.isEdit ? 'Note updated successfully' : 'Note added successfully'])
        this.$emit('saved')
        this.closeDialog()
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    closeDialog () {
      this.noteText = ''
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.add-log-note-dialog {
  box-shadow: 0px 4px 10.2px 0px rgba(0, 0, 0, 0.16) !important;
}
.w-full {
  width: 100%;
}
.invisible {
  visibility: hidden;
}
.log-icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  background-color: var(--v-neutral300);
}
.min-width-0 {
  min-width: 0;
}
</style>
